var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lead-status"},[_c('span',{staticClass:"lead-status-name"},[_vm._v(_vm._s(_vm.lead_status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }